import React from 'react';
import { 
    Backdrop,
    CircularProgress,
    Skeleton,
    Stack
} from '@mui/material';

export default function TableOverlay() {
  return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        className='table-backdrop'
      >
        <CircularProgress color="inherit" />
      </Backdrop>
  ) 
}
